export type SelectOption = {
  label: string;
  value: string;
  disabled?: boolean;
  description?: string;
  [key: string]: unknown;
};

export type SelectOptGroup = {
  label: string;
  options: SelectOption[];
};

export const isSelectOptGroup = (entry: SelectOption | SelectOptGroup): entry is SelectOptGroup => {
  if (!entry) {
    return false;
  }

  return 'options' in entry && Array.isArray(entry.options);
};

export const getOptionIndex = (options: NonNullable<(SelectOption | SelectOptGroup)[]>, value: string): number => {
  if (!value || !options || options?.length === 0) {
    return -1;
  }

  const flattenedOptions = options.flatMap((item) => (isSelectOptGroup(item) ? (item.options as SelectOption[]) : [item]));
  return flattenedOptions.findIndex((option) => option.value === value);
};

export const getOptionFromIndex = (options: NonNullable<(SelectOption | SelectOptGroup)[]>, index: number): SelectOption | undefined => {
  if (index < 0 || !options || options?.length === 0) {
    return undefined;
  }

  const flattenedOptions = options.flatMap((item) => (isSelectOptGroup(item) ? (item.options as SelectOption[]) : [item]));
  return flattenedOptions[index];
};

export const getLabelFromValue = (value: string, options: (SelectOption | SelectOptGroup)[]): string => {
  for (const entry of options) {
    if (isSelectOptGroup(entry)) {
      const foundOption = entry.options.find((option) => option.value === value);
      if (foundOption) {
        return foundOption.label;
      }
    } else if (entry.value === value) {
      return entry.label;
    }
  }
  return '';
};
